import React from 'react'

type Props = {}

/**
 * TBD, see https://github.com/kobotoolbox/kpi/issues/4594
 */
export default function KeywordSearchResponseForm({}: Props) {
  return null // TODO: implement. See git history.
}
